module.exports = __webpack_public_path__ + "img/logographiko.40a192c8.png";